import { PlusIcon } from "@xola/icons";
import { Button } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { Permission } from "types";
import { IsGranted } from "../../Common/IsGranted";
import { ContentLayout } from "../../Layout/ContentLayout";
import { TermsTemplateTable } from "./TermsTemplateTable";

export const TermsTemplateList = () => {
    const history = useHistory();

    return (
        <ContentLayout isWide>
            <div className="mb-4 flex items-center justify-between">
                <h2>Manage Templates</h2>

                <IsGranted isAny permissions={[Permission.MODIFY_PARTNERS, Permission.OPERATORS_ACTIONS]}>
                    <Button
                        color="primary"
                        icon={<PlusIcon />}
                        onClick={() => {
                            history.push("/distribution/termsTemplates/create");
                        }}
                    >
                        Create Template
                    </Button>
                </IsGranted>
            </div>

            <TermsTemplateTable showActions />
        </ContentLayout>
    );
};
